// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export async function fulfilledResults<T>(promises: Promise<T>[]) {
  return (await Promise.allSettled(promises))
    .filter((r) => r.status === 'fulfilled')
    .map((r) => (r as PromiseFulfilledResult<T>).value);
}
